export class DropdownOptionModel<T> {
  display: string;
  value: T;

  public static getDisplay<T>(enumOptions: DropdownOptionModel<T>[], enumValue: T): string {
    const index = enumOptions.map(option => option.value).indexOf(enumValue);
    return index >= 0 ? enumOptions[index].display : '';
  }
}
